var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor-container"},[_c('search-card'),_c('table-card',{staticStyle:{"margin-top":"30px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }